module.exports = __webpack_public_path__ + "img/cr.e6867779.png";